module.exports = __webpack_public_path__ + "img/skrill_static.ec1a287f.svg";